import FormScreen from '@components/CustomForm/CloudPayments/FormScreen';
import SuccessScreen from '@components/CustomForm/SuccessScreen';
import type {CustomFormProps} from '@interfaces/CustomForm';
import type {ReactElement} from 'react';
import {useEffect, useState} from 'react';
import {sendEventLog} from '@api/analytics';

const FORM_SCREEN = 'formScreen';
const SUCCESS_SCREEN = 'successScreen';

export default function CustomForm(props: CustomFormProps): ReactElement<CustomFormProps> {
    const [currentScreen, setCurrentScreen] = useState(FORM_SCREEN);

    useEffect(() => {
        sendEventLog('custom_form_load').catch(() => {
            /* do nothing */
        });
    }, []);

    function handleAfterSuccessfulPayment() {
        setCurrentScreen(SUCCESS_SCREEN);
    }

    return (
        <div className="custom-form">
            {currentScreen === FORM_SCREEN && (
                <FormScreen {...props} onAfterSuccessfulPayment={handleAfterSuccessfulPayment} />
            )}
            {currentScreen === SUCCESS_SCREEN && <SuccessScreen />}
        </div>
    );
}
